
import { Box } from "@chakra-ui/layout";
import "./styles.css";
import SingleChat from "./SingleChat";
import { ChatState } from "../context/chatProvider";
import { Button } from "@chakra-ui/react";
import { refreshPage } from "../config/ChatLogistics";


const ChatBox = ({ fetchAgain,setFetchAgain }) => {
   

 const { selectedChat } = ChatState();

  return (
    <Box
      display={{ base: selectedChat ? "flex" : "none", md: "flex" }}
      alignItems="center"
      flexDir="column"
      p={3}
      bg="white"
      w={{ base: "100%", md: "55%" }}
      borderRadius="10px 0 10px 10px"
      borderWidth="1px"
      boxShadow={"bxshd.inset_blk"}
      background={"#fff"}
      // background={"bgs.gradBlk"}
      color={"txt.hdrDrk"}
      border={'1px solid txt.hdrDrk'}
      variant="ghost" 
      // backgroundImage={`url('bg.main2')`}
      backgroundSize={"cover"}
      // boxShadow={"bxshd.mainComp_ChtBx"}
    >
      <SingleChat fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
      {/* <Button onClick={()=>{refreshPage()}} >Refresh</Button> */}
    </Box>
  
  )
}

export default ChatBox